import { defineMessages } from "react-intl";

const MY_EBSCO_DATA_PRIVACY = "my-ebsco-data-privacy";

const myEbscoDataPrivacyMessages = defineMessages({
  myEbscoDataPrivacyDataCoppaBulletOne: {
    id: `${MY_EBSCO_DATA_PRIVACY}.my-ebsco-data-privacy-data-coppa-bullet-one`,
    defaultMessage:
      "First name or ID number, if shared by you or your institution.",
    description: "Description of Data Privacy Data Non Coppa"
  },
  myEbscoDataPrivacyDataNonCoppaBulletOne: {
    id: `${MY_EBSCO_DATA_PRIVACY}.my-ebsco-data-privacy-data-non-coppa-bullet-one`,
    defaultMessage:
      "Name, email, and ID number, if shared by you or your institution during account creation or login. Some of this information is optional and can be viewed, changed, or removed in your MyEBSCO account management area.",
    description: "Description of Data Privacy Data Non Coppa"
  },
  myEbscoDataPrivacyDataBulletTwo: {
    id: `${MY_EBSCO_DATA_PRIVACY}.my-ebsco-data-privacy-data-non-coppa-bullet-two`,
    defaultMessage: "Items and searches that you save to folders and projects.",
    description: "Description of Data Privacy Data Non Coppa"
  },
  myEbscoDataPrivacyDataBulletThree: {
    id: `${MY_EBSCO_DATA_PRIVACY}.my-ebsco-data-privacy-data-non-coppa-bullet-three`,
    defaultMessage:
      "Your affiliated institutions, such as which library you are authorized to access EBSCO interfaces for.",
    description: "Description of Data Privacy Data Non Coppa"
  },
  myEbscoDataPrivacyDataBulletFour: {
    id: `${MY_EBSCO_DATA_PRIVACY}.my-ebsco-data-privacy-data-non-coppa-bullet-four`,
    defaultMessage:
      "Minimal activity data that allows EBSCO to monitor for security incidents, such as any breach of your credentials, and also to make ongoing improvements to research experiences.",
    description: "Description of Data Privacy Data Non Coppa"
  },
  myEbscoDataPrivacyPolicy: {
    id: `${MY_EBSCO_DATA_PRIVACY}.my-ebsco-data-privacy-policy`,
    defaultMessage:
      "If you would like more specific information related to our data privacy practices, please read EBSCO’s <a>Privacy Policy</a>.",
    description: "Description of Data Privacy Policy"
  },
  dataPrivacyHeading: {
    id: `${MY_EBSCO_DATA_PRIVACY}.data-privacy-heading`,
    defaultMessage: "MyEBSCO data privacy",
    description: "Heading of MyEBSCO Data Privacy"
  },
  dataPrivacyBody: {
    id: `${MY_EBSCO_DATA_PRIVACY}.data-privacy-body`,
    defaultMessage:
      "You are seeing this page because you have a MyEBSCO account. This allows you to save and organize your research, and enables additional features and functionality that increase productivity.",
    description: "Body of MyEBSCO Data Privacy"
  },
  whyIsDataCollectedHeading: {
    id: `${MY_EBSCO_DATA_PRIVACY}.data-collected-heading`,
    defaultMessage: "Why is data collected?",
    description: "Heading of Why is data collected?"
  },
  whyIsDataCollectedBody: {
    id: `${MY_EBSCO_DATA_PRIVACY}.data-collected-body`,
    defaultMessage:
      "EBSCO requires specific data to create and maintain your MyEBSCO account, and to continuously provide a robust, user-friendly research experience.",
    description: "Body of Why is data collected?"
  },
  howItIsUsedHeading: {
    id: `${MY_EBSCO_DATA_PRIVACY}.how-it-is-used-heading`,
    defaultMessage: "What data is collected, and how is it used?",
    description: "Heading of how is it used?"
  },
  howItIsUsedBody: {
    id: `${MY_EBSCO_DATA_PRIVACY}.how-it-is-used-body`,
    defaultMessage:
      "Data that is collected during MyEBSCO account creation may have been provided to EBSCO by you or your institution, depending on how your account was created. Categories of data collected include:",
    description: "Body of how is it used?"
  },
  youControlYourDataHeading: {
    id: `${MY_EBSCO_DATA_PRIVACY}.you-control-your-data-heading`,
    defaultMessage: "You control your data",
    description: "Heading of You control your data"
  },
  youControlYourDataBody: {
    id: `${MY_EBSCO_DATA_PRIVACY}.you-control-your-data-body`,
    defaultMessage:
      "You can delete your MyEBSCO account and any data associated with it at any time. This will delete any saved items and continuing education credits. You will still be able to access EBSCO products anonymously through your institution, but you may lose the ability to use certain research functionality, such as placing holds on EBSCO eBooks and persistently saving research.",
    description: "Body of You control your data"
  }
});

export default myEbscoDataPrivacyMessages;
